

































































































































































































































import { Component, Vue, Emit, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { DateTime } from 'luxon'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'
import { maskMoney, maskDateTime, maskCPFCNPJ } from '@/utils/common'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import { Loading } from '@/types/_'

@Component

export default class ComponentModalNFExtrato extends Vue {
  @Prop({ required: true, default: false }) disabled: boolean
  $refs!: {
    formRules: any,
    dateA: any,
    documentosPdf: any,
    documentosXml: any,
    documentosAdicionais: any
  }

  formRules: any = {
    valid: true,
    dataRecebimentoNota: [v => !!v || 'O campo data de recebimento da nota é obrigatório.'],
    numeroNota: [v => !!v || 'O campo número da nota é obrigatório.'],
    numeroContasPagar: [v => !!v || 'O campo número contas a pagar é obrigatório.'],
    valorNotaFiscal: [v => !!v || 'O campo valor da nota é obrigatório.'],
  }

  loadDeletar: boolean = false
  loadConfirmar: boolean = false
  motivo: any[] = []
  dateText1: string = ''
  imageUrl: string = ''
  anexo: any = {}
  anexoXML: any = {}
  anexoDocumentos: any = {}
  arquivoNome: any = ''
  enableConfirmar: boolean = false
  loading: Loading = {
    status: false,
    text: '',
  }

  showMessageLimitDocuments: boolean = false
  inputFilePDF: any[] = []
  inputFileXML: any[] = []
  inputFileAdicional: any[] = []
  notasFiscais: any[] = []
  documentosAdicionais: any[] = []

  get loadingDeletar() {
    return this.loadDeletar
  }

  set loadingDeletar(value: boolean) {
    this.loadDeletar = value
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get recebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get showModal() {
    return this.recebimentoStore.modalDadosNF
  }

  get anexoNotaFiscal() {
    return this.anexo
  }

  set anexoNotaFiscal(value: any) {
    this.anexo = value
  }

  get anexoNotaFiscalXML() {
    return this.anexoXML
  }

  set anexoNotaFiscalXML(value: any) {
    this.anexoXML = value
  }

  get anexoDocumentosAdicionais() {
    return this.anexoDocumentos
  }

  set anexoDocumentosAdicionais(value: any) {
    this.anexoDocumentos = value
  }

  get nomeArquivoOriginal() {
    return this.arquivoNome
  }

  set nomeArquivoOriginal(value: string) {
    this.arquivoNome = value
  }

  get numeroNota() {
    return this.recebimentoStore.numeroNota
  }

  set numeroNota(value: string) {
    this.recebimentoStore.setNumeroNota(value)
  }

  get valorNotaFiscal() {
    return this.recebimentoStore.valorNotaFiscal
  }

  set valorNotaFiscal(value: number) {
    this.recebimentoStore.setValorNotaFiscal(value)
  }

  get isEnableConfirmar() {
    return this.enableConfirmar
  }

  set isEnableConfirmar(value: boolean) {
    this.enableConfirmar = value
  }

  get getRequestMessage() {
    return this.recebimentoStore.requestMessage
  }

  get getRecebimento() {
    return this.recebimentoStore.nfSelected
  }

  get permiteNotaFiscalXml() {
    return this.getRecebimento.acoes ? this.getRecebimento.acoes.permiteNotaFiscalXml : false
  }

  get permiteDocumentosAdicionais() {
    return this.getRecebimento.acoes ? this.getRecebimento.acoes.habilitaDocumentoAdicional : false
  }

  get documentoAdicionalObrigatorio() {
    return this.getRecebimento.acoes ? this.getRecebimento.acoes.documentoAdicionalObrigatorio : false
  }

  get qtdDocumentosAdicionais() {
    return this.getRecebimento.documentosAdicionais ? this.getRecebimento.documentosAdicionais.length : 0
  }

  get totalDocumentosAdicionais() {
    return this.qtdDocumentosAdicionais + this.documentosAdicionais.length
  }

  get minimoDocumentosAdicionais() {
    return this.getRecebimento.acoes ? this.getRecebimento.acoes.minimoDocumentoAdicional : 0
  }

  get maximoDocumentosAdicionais() {
    return this.getRecebimento.acoes.maximoDocumentoAdicional
  }

  get dadosNfObrigatorios() {
    return this.getRecebimento.extratoDadosNfObrigatorios
  }

  isDocumentosAdicionaisNoRange() {
    if (!this.permiteDocumentosAdicionais) {
      this.showMessageLimitDocuments = false
      return true
    }

    const minimoExigido = this.documentoAdicionalObrigatorio ? this.minimoDocumentosAdicionais : 0
    const total = this.totalDocumentosAdicionais

    this.showMessageLimitDocuments = total === this.maximoDocumentosAdicionais

    return total >= minimoExigido && total <= this.maximoDocumentosAdicionais
  }

  temPdfNotaFiscal() {
    const notasDoRecebimento = this.getRecebimento ? this.getRecebimento.notasFiscais : []
    const notasDaTela = this.notasFiscais || []

    const temPdfNoRecebimento = notasDoRecebimento.some((nf: any) => nf.nomeArquivoOriginal.toLowerCase().endsWith('.pdf'))
    const temPdfNaTela = notasDaTela.some((nf: any) => nf.nomeArquivoOriginal.toLowerCase().endsWith('.pdf'))

    return this.inputFilePDF.length > 0 || temPdfNaTela || temPdfNoRecebimento
  }

  atualizarEstadoConfirmar() {
    const temPDFLocal = this.inputFilePDF.length > 0
    const temPDFNaTela = this.notasFiscais.some(nf => nf.nomeArquivoOriginal.endsWith('.pdf'))
    const temPDF = temPDFLocal || temPDFNaTela

    if (!temPDF) {
      this.isEnableConfirmar = false
      return
    }

    const documentosValidos = this.isDocumentosAdicionaisNoRange()
    if (documentosValidos) {
      this.showMessageLimitDocuments = false
    }

    this.isEnableConfirmar = documentosValidos
  }

  async confirmar() {
    this.loadingConfirmar = true

    const { files } = this.$refs.documentosPdf.$refs.upload

    if (this.$refs.formRules.validate()) {
      if (this.permiteNotaFiscalXml && !this.temPdfNotaFiscal()) {
        EventBus.$emit('setSnackbar', { show: true, text: 'É necessário anexar uma nota fiscal PDF para salvar quando o XML estiver habilitado.', icon: 'warning', color: '#C62828' })
        this.loadingConfirmar = false
        return false
      }

      if (!this.permiteDocumentosAdicionais && files.length < 1 && this.nomeArquivoOriginal === '') {
        EventBus.$emit('setSnackbar', { show: true, text: 'É necessário anexar uma nota fiscal.', icon: 'warning', color: '#C62828' })
        this.loadingConfirmar = false
        return false
      }

      if (this.permiteDocumentosAdicionais && !this.isDocumentosAdicionaisNoRange()) {
        EventBus.$emit('setSnackbar', { show: true, text: 'A quantidade de documentos adicionais está fora do limite permitido.', icon: 'warning', color: '#C62828' })
        this.loadingConfirmar = false
        return false
      }

      // Verifica se não tem arquivos anexados e implementa lógica para excluir e atualizar
      if (!this.getRecebimento.acoes.permiteMultiplasNFs && this.inputFilePDF.length > 0 && this.getRecebimento.notasFiscais.length > 0) {
        for (let i = 0; i < this.getRecebimento.notasFiscais.length; i++) {
          const nota = this.getRecebimento.notasFiscais[i]
          const paramsDelete: any = {
            prestadorRecebimentoId: this.getRecebimento.id,
            documentoId: nota.documentoId,
          }
          await this.getFinanceiroStore.deletarDocumento(paramsDelete)
        }
      }

      // 1. Upload PDF
      if (files.length > 0) {
        if (this.getRecebimento.acoes.permiteMultiplasNFs) {
          for (let i = 0; i < this.notasFiscais.length; i++) {
            const nota = this.notasFiscais[i]
            const params: any = {
              prestadorRecebimentoId: this.recebimentoStore.nfSelected.id,
              formData: nota.formData,
            }

            await this.getFinanceiroStore.uploadNotaFiscalUnica({ params, typeFile: 'pdf' })
          }
        } else {
          const params: any = {
            prestadorRecebimentoId: this.recebimentoStore.nfSelected.id,
            formData: this.anexoNotaFiscal.formData,
          }
          const step1 = await this.getFinanceiroStore.uploadNotaFiscalUnica({ params, typeFile: 'pdf' })
          if (!step1.success) {
            EventBus.$emit('setSnackbar', { show: true, text: step1.message || 'Houve um problema ao enviar nota fiscal PDF', icon: 'warning', color: '#C62828' })
            this.loadingConfirmar = false
            return false
          }
          files.splice(0, files.length)
        }
      }

      // 2. Upload XML (se existir)
      if (this.permiteNotaFiscalXml && this.inputFileXML.length > 0) {
        const formDataXML = new FormData()
        formDataXML.append('notaFiscal', this.inputFileXML[0])

        const paramsXML: any = {
          formData: formDataXML,
          prestadorRecebimentoId: this.recebimentoStore.nfSelected.id,
        }

        const stepXML = await this.getFinanceiroStore.uploadNotaFiscalUnica({ params: paramsXML, typeFile: 'xml' })
        if (!stepXML.success) {
          EventBus.$emit('setSnackbar', { show: true, text: stepXML.message || 'Houve um problema ao enviar o XML da nota fiscal', icon: 'warning', color: '#C62828' })
          this.loadingConfirmar = false
          return false
        }
      }

      // 3. Upload documentos adicionais (se existir)
      if (this.permiteDocumentosAdicionais && this.documentosAdicionais.length > 0) {
        const formDataAdicionais = new FormData()

        // Adicionar todos os arquivos ao FormData
        this.documentosAdicionais.forEach((doc) => {
          formDataAdicionais.append('files', doc.file)
        })

        const params: any = {
          prestadorRecebimentoId: this.recebimentoStore.nfSelected.id,
          formData: formDataAdicionais,
        }

        const stepDoc = await this.getFinanceiroStore.uploadDocumentosAdicionais(params)
        if (!stepDoc.success) {
          EventBus.$emit('setSnackbar', { show: true, text: stepDoc.message || 'Houve um problema ao enviar os documentos adicionais', icon: 'warning', color: '#C62828' })
          this.loadingConfirmar = false
          return false
        }
      }

      // 4. Atualizar recebimento (sempre executar após uploads)
      const params: any = {
        prestadorRecebimentoId: this.recebimentoStore.nfSelected.id,
        numeroNota: this.numeroNota,
        valorNotaFiscal: this.valorNotaFiscal,
        dataRecebimentoNota: DateTime.local().toISO(),
        numeroContasPagar: '0',
        motivo: ['Nenhum'],
      }

      if (this.recebimentoStore.nfSelected.acoes.permiteMultiplasNFs || this.permiteNotaFiscalXml) {
        params.documentoId = this.getFinanceiroStore.documentoId
      }

      const response = await this.getFinanceiroStore.atualizarRecebimetno(params)

      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Nota Fiscal atualizada com sucesso.', icon: 'done', color: '#2E7D32' })
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema na atualização da nota fiscal.', icon: 'warning', color: '#C62828' })
      }
    }

    this.loadingConfirmar = false
    return false
  }

  async deletar() {
    this.loadingDeletar = true

    const params: any = {
      prestadorRecebimentoId: this.recebimentoStore.nfSelected.id,
    }
    const response = await this.getFinanceiroStore.deletarDocumento(params)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Nota Fiscal deletada com sucesso.', icon: 'done', color: '#2E7D32' })
      this.getFinanceiroStore.setNotaFIscalItemAnexo('')
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema ao deletar nota fiscal.', icon: 'warning', color: '#C62828' })
    }

    this.loadingDeletar = false
  }

  changeFile(e, typeFile: string) {
    if (!e) return

    const { file } = e
    const { type } = file
    const fileName = file.name.toLowerCase()

    if (!file || file.identifier) {
      return
    }

    // Validar tipo e extensão
    const isValidXML = type === 'application/xml' || type === 'text/xml' || fileName.endsWith('.xml')
    const isValidPDF = type === 'application/pdf' || fileName.endsWith('.pdf')

    if (this.permiteNotaFiscalXml) {
      if (!isValidXML && !isValidPDF) {
        EventBus.$emit('setSnackbar', { show: true, text: 'O arquivo enviado não possui formato válido. Apenas PDF e XML são permitidos.', icon: 'warning', color: '#C62828' })
        return
      }
    } else if (!isValidPDF) {
      EventBus.$emit('setSnackbar', { show: true, text: 'O arquivo enviado não possui formato válido. Apenas PDF é permitido.', icon: 'warning', color: '#C62828' })
      return
    }

    const formData = new FormData()
    const nota = {
      nomeArquivoOriginal: fileName,
      documentoId: '',
    }

    if (typeFile !== 'adicionais') {
      formData.append('notaFiscal', file)

      const params: any = {
        formData,
        prestadorRecebimentoId: this.recebimentoStore.nfSelected.id,
      }

      this.getFinanceiroStore.setNotaFIscalItemAnexo(file.name)
      this.nomeArquivoOriginal = file.name

      if (isValidXML) {
        this.anexoNotaFiscalXML = params
        this.inputFileXML = [file]
      } else if (isValidPDF) {
        this.anexoNotaFiscal = params
        this.inputFilePDF = [file]
      }

      if (this.getRecebimento.acoes.permiteMultiplasNFs) {
        this.notasFiscais.push({
          nomeArquivoOriginal: fileName,
          documentoId: '',
          formData,
        })
      } else {
        const index = this.notasFiscais.findIndex(
          nf => nf.nomeArquivoOriginal.endsWith(type === 'application/pdf' ? '.pdf' : '.xml'),
        )

        if (index >= 0) {
          this.notasFiscais.splice(index, 1, nota)
        } else {
          this.notasFiscais.push(nota)
        }
      }
    } else if (isValidPDF) {
      this.inputFileAdicional.push(file)
      this.documentosAdicionais.push({
        nomeArquivoOriginal: fileName,
        documentoId: '',
        file,
      })

      if (this.totalDocumentosAdicionais === this.maximoDocumentosAdicionais) {
        this.showMessageLimitDocuments = true
        return
      }
    }

    this.atualizarEstadoConfirmar()

    EventBus.$emit('setSnackbar', { show: true, text: `Arquivo ${isValidXML ? 'XML' : 'PDF'} selecionado com sucesso.`, icon: 'done', color: '#2E7D32' })
  }

  removeFile(nota: any, index: number, typeFile?: string) {
    if (nota.nomeArquivoOriginal.endsWith('.xml')) {
      this.inputFileXML.splice(index, 1)
      this.notasFiscais.splice(index, 1)
      this.anexoNotaFiscalXML = {}
    } else if (typeFile !== 'adicional') {
      this.inputFilePDF.splice(index, 1)
      this.notasFiscais.splice(index, 1)
      this.anexoNotaFiscal = {}
    } else {
      this.inputFileAdicional.splice(index, 1)
      this.documentosAdicionais.splice(index, 1)
    }

    this.atualizarEstadoConfirmar()
  }

  async download(prestadorRecebimentoId: string) {
    const response = await this.getFinanceiroStore.download({ prestadorRecebimentoId })
    const win = window.open()
    // @ts-ignore
    win.document.body.style.margin = '0'
    // @ts-ignore
    win.document.body.style.padding = '0'
    // @ts-ignore
    const iframe = win.document.createElement('iframe')
    iframe.src = response.data
    iframe.setAttribute('frameborder', '0')
    iframe.setAttribute('allowfullscreen', '')
    // Estilo via cssText (CSSOM): a CSP herdada pela janela bloqueia atributo style inline
    iframe.style.cssText = 'border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%; margin:-8px;'
    // @ts-ignore
    win.document.body.appendChild(iframe)
  }

  async closeModal() {
    this.recebimentoStore.setModalDadosNF(false)
    this.$refs.formRules.reset()
    this.recebimentoStore.clearModalDadosNF()
    this.nomeArquivoOriginal = ''
    this.clearNfs()
    this.isEnableConfirmar = false
    this.setLoadingRequest(true, this.getRequestMessage.init.text)
    await this.recebimentoStore.loadRecebimentos()
    this.clearLoadingRequest()
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  clearNfs() {
    this.inputFilePDF = []
    this.inputFileXML = []
    this.inputFileAdicional = []
    this.notasFiscais = []
    this.documentosAdicionais = []
    this.showMessageLimitDocuments = false
    this.anexoNotaFiscal = {}
    this.anexoNotaFiscalXML = {}
  }

  setLoadingRequest(status: boolean, text: string) {
    this.loading.status = status
    this.loading.text = text
  }

  formatMoneyUtil(money: string) {
    return maskMoney(money)
  }

  maskCPFCNPJUtil(value: string) {
    return maskCPFCNPJ(value)
  }

  maskDateTime(value: string) {
    return maskDateTime(value)
  }

  @Watch('showModal')
  onShowModalChange(newVal: boolean) {
    if (newVal) {
      this.notasFiscais = this.getRecebimento.notasFiscais ? [...this.getRecebimento.notasFiscais] : []
      if (this.notasFiscais.length > 0) {
        const temPdf = this.notasFiscais.some((nf: any) => nf.nomeArquivoOriginal.toLowerCase().endsWith('.pdf'))
        if (temPdf) {
          this.numeroNota = this.notasFiscais[0].numeroNota || ''
          this.valorNotaFiscal = this.notasFiscais[0].valorNotaFiscal || 0
          this.isEnableConfirmar = true
        }
      }
    }
  }
}
